/**手册类型 */
export enum BOOK_MAP_TYPE {
  'UM' = '用户手册',
  'RM' = '维修手册',
  'CRM' = '车身维修手册',
  'DT' = '电路图手册',
  'ST' = '维修工具',
  'RE' = '救援卡'
}
